import React from "react";
import { motion } from "framer-motion";
import {
  imgNbaLogo,
  imgPartner2,
  imgPartner3,
  imgPartner5,
  imgPartner6,
} from "../../assets";

export default function Partners() {
  return (
    <motion.section
      className="partners"
      data-node-id="252:187"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.4 }}
      variants={{
        hidden: { opacity: 0, y: 10 },
        show: {
          opacity: 1,
          y: 0,
          transition: { staggerChildren: 0.1, delayChildren: 0.05 },
        },
      }}
    >
      <div className="container">
        <motion.h2
          className="partners__title"
          data-node-id="203:1876"
          variants={{
            hidden: { opacity: 0, y: 10 },
            show: { opacity: 1, y: 0 },
          }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          Our Trusted Partners
        </motion.h2>
        <motion.div
          className="partners__row"
          data-node-id="252:185"
          variants={{ hidden: { opacity: 0 }, show: { opacity: 1 } }}
        >
          <motion.img
            className="partners__logo"
            src={imgNbaLogo}
            alt="Partner"
            style={{ width: 80, height: 81 }}
            data-node-id="252:184"
            variants={{
              hidden: { opacity: 0, y: 10 },
              show: { opacity: 1, y: 0 },
            }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            whileHover={{ y: -4 }}
          />
          <motion.img
            className="partners__logo"
            src={imgPartner2}
            alt="Partner"
            style={{ width: 117, height: 32 }}
            data-node-id="251:168"
            variants={{
              hidden: { opacity: 0, y: 10 },
              show: { opacity: 1, y: 0 },
            }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            whileHover={{ y: -4 }}
          />
          <motion.img
            className="partners__logo"
            src={imgPartner3}
            alt="Partner"
            style={{ width: 95, height: 32 }}
            data-node-id="251:171"
            variants={{
              hidden: { opacity: 0, y: 10 },
              show: { opacity: 1, y: 0 },
            }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            whileHover={{ y: -4 }}
          />
          <motion.img
            className="partners__logo"
            src={imgPartner5}
            alt="Partner"
            style={{ width: 101, height: 36 }}
            data-node-id="251:177"
            variants={{
              hidden: { opacity: 0, y: 10 },
              show: { opacity: 1, y: 0 },
            }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            whileHover={{ y: -4 }}
          />
          <motion.img
            className="partners__logo"
            src={imgPartner6}
            alt="Partner"
            style={{ width: 99, height: 22 }}
            data-node-id="251:180"
            variants={{
              hidden: { opacity: 0, y: 10 },
              show: { opacity: 1, y: 0 },
            }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            whileHover={{ y: -4 }}
          />
        </motion.div>
      </div>
    </motion.section>
  );
}
